import React from 'react'
import { isEmpty, isNil } from 'lodash'

import { ExternalLink } from '@/components/ExternalLink'

import { formatSourcePages } from './AiAnswers.helpers'
import './AiAnswers.scss'

/**
 * The documents an AI answer cited.
 *
 * Only SharePoint-ingested documents carry a URL, so uploaded customer documents
 * and Top Agents answers render as plain titles.
 *
 * @param {Array<{title: string, url?: string, page?: string}>} props.sources
 */
export const AiAnswerSources = ({ sources = [] }) => {
  if (isEmpty(sources)) {
    return null
  }

  return (
    <ul className="ai-answer-sources">
      {sources.map((source) => (
        <li
          key={`${source.title}-${source.url}-${source.page}`}
          className="ai-answer-sources__item"
        >
          {isNil(source.url) ? (
            <span>{source.title}</span>
          ) : (
            <ExternalLink url={source.url} label={source.title} wrap />
          )}
          {!isNil(source.page) && (
            <span className="muted-text small-text">{formatSourcePages(source.page)}</span>
          )}
        </li>
      ))}
    </ul>
  )
}
